module.exports = __webpack_public_path__ + "img/product-18.cf0ae7d9.jpg";